import { Tag } from '@weave/schema-gen-ts/dist/schemas/tag/shared/v1/models.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text, usePopoverMenu } from '@frontend/design-system';
import { TagsSelectPopover } from './tags-select-popover';

type Props = {
  tags: Tag[];
  selectTags: (tagIds: string[]) => void;
  selectedTags: string[];
  closeParentMenu: () => void;
};
export const TagsFilterMenuItem = ({ tags, selectTags, selectedTags, closeParentMenu }: Props) => {
  const { t } = useTranslation('fax');
  const tagsPopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
  });

  return (
    <>
      <PopoverMenuItem
        {...tagsPopover.getTriggerProps()}
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          svg: { fill: theme.colors.neutral50 },
          cursor: 'pointer',
          transition: 'background-color 150ms ease-in-out',
          overflow: 'hidden',
          gap: theme.spacing(2),
          padding: 0,
          marginTop: theme.spacing(-1),
        }}
      >
        <div css={{ display: 'flex', gap: theme.spacing(1) }}>
          <Icon name='label' size={24} color='light' />
          <Text>{t('Tags')}</Text>
        </div>
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          {selectedTags?.length > 0 && (
            <Text
              size='small'
              css={{
                color: theme.colors.primary70,
                padding: theme.spacing(0.25, 0.5),
                borderRadius: theme.borderRadius.small,
                backgroundColor: theme.colors.primary10,
              }}
            >
              {selectedTags?.length}
            </Text>
          )}
          <Icon name='alt-caret-right-tiny' color='light' />
        </div>
      </PopoverMenuItem>
      <TagsSelectPopover
        tags={tags}
        selectTags={selectTags}
        selectedTags={selectedTags}
        closeParentMenu={closeParentMenu}
        getMenuProps={tagsPopover.getMenuProps}
        getItemProps={tagsPopover.getItemProps}
      />
    </>
  );
};
